enum OpenQuestionReviewType {
  NOTE = "NOTE",
  APPROVAL = "APPROVAL",
  REJECTION = "REJECTION"
}

export default OpenQuestionReviewType